import { CONFIGURATOR_INPUT_SCALAR_NULL_VALUE } from "src/components/views/erp/configurator/configuratorUtils.ts";
import { ConfiguratorFieldComponentProps } from "src/components/views/erp/configurator/configuratorForm/components/field/ConfiguratorFieldComponent.tsx";
import { getConfiguratorFieldComponentLabelWithRequiredMark } from "src/components/views/erp/configurator/configuratorForm/components/field/configuratorFieldComponentUtils.ts";
import { getConfiguratorComponentErrorMessage } from "src/components/views/erp/configurator/configuratorForm/validation.ts";
import { ConfiguratorInput_InputValue_Scalar } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorInput";
import { AavoNumberField } from "src/components/common/inputFields/AavoNumberField.tsx";

interface ConfiguratorNumberFieldProps extends ConfiguratorFieldComponentProps {}

export const ConfiguratorNumberField = ({ field, onChange, onSubmit, disabled }: ConfiguratorNumberFieldProps) => {
	const convertValue = (newValue: number | null): ConfiguratorInput_InputValue_Scalar => {
		if (newValue == null || isNaN(newValue)) {
			return CONFIGURATOR_INPUT_SCALAR_NULL_VALUE;
		}

		return {
			type: "SCALAR",
			propertyValue: {
				type: field.fieldType === "INTEGER" ? "int" : "decimal",
				value: newValue,
				label: newValue.toString(),
				fileUuid: field.imageUuid,
			},
		};
	};

	return (
		<AavoNumberField
			label={getConfiguratorFieldComponentLabelWithRequiredMark(field)}
			disabled={!field.enabled || disabled}
			value={getNumberValue()}
			onChange={(newValue) => {
				onChange(convertValue(newValue));
			}}
			onSubmit={async (newValue) => {
				await onSubmit(convertValue(newValue));
			}}
			error={getConfiguratorComponentErrorMessage(field)}
			sx={{
				flex: 1,
			}}
			type={field.fieldType === "INTEGER" ? "integer" : "decimal"}
		/>
	);

	function getNumberValue(): number | null {
		const asPropertyValue = field.currentValue.propertyValue;
		switch (asPropertyValue.type) {
			case "int":
			case "decimal":
				return asPropertyValue.value;
			default:
				return null;
		}
	}
};
